function Skills(){
    return(
        <div></div>
    )
}

export default Skills